<template>
    <div>
        <a-button @click="showModal" class="btn-outline-primary"  icon="eye">
             پاسخ نظرسنجی
        </a-button>

        <a-modal width="1000px" v-model="visible" title="  پاسخ نظرسنجی  " on-ok="handleOk">
            <template slot="footer">
                <a-button key="back" @click="handleCancel">
                    بستن
                </a-button>
            </template>
            <div class="text-right" v-for="item in answers">
                <div > <strong>{{  item.question.description }}</strong></div>
                <br>
    <span
    >
      {{ item.answer.description }}
    </span>
<hr>
  </div>


        </a-modal>
    </div>
</template>
<script>
    export default {
        props: {
            answers: Object,
        },
        data() {
            return {
                loading: false,
                visible: false,
                
            };
        },
        methods: {
          
            showModal() {
                this.visible = true;
            },
            handleOk(e) {
                this.loading = true;
                setTimeout(() => {
                    this.visible = false;
                    this.loading = false;
                }, 3000);
            },
            handleCancel(e) {
                this.visible = false;
            },
            
        },
    };
</script>
